import React from 'react';
import cn from 'classnames';

import * as styles from './index.module.css';

type CounterVariant = 'critical' | 'brandPrimary' | 'secondary';

export type CounterProps = {
  variant?: CounterVariant;
  value: number;
  className?: string;
};

export function Counter({ value, variant = 'brandPrimary', className }: CounterProps) {
  return <div className={cn(className, styles[variant], styles.counter)}>{value}</div>;
}
